import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item"]

  initialize() {
    this.currentIndex = 0
    this.totalItems = this.itemTargets.length
    this.isAnimating = false
  }

  connect() {
    this.updateCarousel()
    window.addEventListener("resize", () => this.handleResize())
  }

  disconnect() {
    window.removeEventListener("resize", () => this.handleResize())
  }

  handleResize() {
    this.currentIndex = 0
    this.updateCarousel()
  }

  next() {
    if (this.isAnimating) return

    const maxIndex = this.totalItems - this.getItemsPerView()
    if (this.currentIndex < maxIndex) {
      this.currentIndex++
    } else {
      this.currentIndex = 0
    }
    this.updateCarousel()
  }

  prev() {
    if (this.isAnimating) return

    if (this.currentIndex > 0) {
      this.currentIndex--
    } else {
      this.currentIndex = this.totalItems - this.getItemsPerView()
    }
    this.updateCarousel()
  }

  getItemsPerView() {
    const width = window.innerWidth
    if (width < 768) return 1
    if (width < 1280) return 2
    return 3
  }

  updateCarousel() {
    if (this.itemTargets.length === 0) return

    this.isAnimating = true
    const itemWidth = this.itemTargets[0].offsetWidth
    const scrollAmount = this.currentIndex * itemWidth

    this.containerTarget.scrollTo({
      left: scrollAmount,
      behavior: "smooth"
    })

    setTimeout(() => {
      this.isAnimating = false
    }, 500)
  }
}
